<template>
  <div>
    <Loader ref="Loader"></Loader>
    <v-flex xs12>
      <v-card>
        <v-toolbar dense color="secondary" dark>
          <v-toolbar-title>Ops Manager - Customer Visit Summary</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <!-- FILTER -->
        <v-flex xs12 sm12 lg12>
          <v-card elevation-5 dark>
            <v-card-title class="title">Filters</v-card-title>
            <v-layout ma-2>
              <v-flex lg6 xs6 sm6 mr-2>
                <v-combobox v-model="selectedOpsManager" label="Select ops-manager" :items="opsManagerList"
                  item-text="FullName" item-value="ID" @change="checkSelectedOpsManager()"
                  :disabled="opsManagerList.length == 0"></v-combobox>
              </v-flex>
              <v-flex lg3 xs3 sm3 mr-2>
                <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" :nudge-right="40" lazy
                  transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="startDateFormatted" label="Start Date" hint="MM/DD/YYYY format"
                      persistent-hint prepend-icon="event" @blur="startDate = parseStartDate(startDateFormatted)"
                      v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="startDate" no-title @input="menu1 = false"></v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex lg3 xs3 sm3 mr-2>
                <v-menu ref="menu1" v-model="menu2" :close-on-content-click="false" :nudge-right="40" lazy
                  transition="scale-transition" offset-y full-width max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="endDateFormatted" label="End Date" hint="MM/DD/YYYY format" persistent-hint
                      prepend-icon="event" @blur="endDate = parseEndDate(endDateFormatted)" v-on="on"></v-text-field>
                  </template>
                  <!-- <v-date-picker v-model="endDate" no-title @input=""> -->
                  <v-date-picker v-model="endDate" no-title @input="menu2 = false"></v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout justify-end ma-2 row>
              <download-excel v-if="opsManagerItems.length > 0" :data="opsManagerItems" :fields="excelFields"
                :name="'Ops-manager-visits-' + today">
                <v-btn color="info">Export</v-btn>
              </download-excel>
              <v-btn flat outline @click="filterItems()">Filter</v-btn>
              <v-btn flat outline @click="clearFilter()">Clear Filter</v-btn>
            </v-layout>
          </v-card>
        </v-flex>
        <v-layout row wrap ma-2>
          <v-layout ma-2>
            <v-flex xs3>
              <h3>Visit Detail Per Ops Manager</h3>
            </v-flex>
          </v-layout>
          <v-container>
            <v-layout mr-2>
              <v-spacer></v-spacer>
              <v-flex xs4>
                <v-text-field append-icon="search" v-model="search" placeholder="Search ops-manager visits">
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-flex d-flex lg12 sm12 xs12>
              <v-data-table class="table" :headers="opsManagerItemHeaders" :items="opsManagerItems"
                :rows-per-page-items="[50, 75, 100]" :search="search">
                <template v-slot:items="props">
                  <td>{{ props.index + 1 }}</td>
                  <td class="text-xs-left">{{ props.item.OpsManagerFullName }}</td>
                  <td class="text-xs-left">{{ props.item.CustomerName }}</td>
                  <td class="text-xs-left">{{ props.item.VenueName }}</td>
                  <!--                  <td class="text-xs-left">{{ props.item.VisitType }}</td>-->
                  <td class="text-xs-left">{{ props.item.AllocatedVisits }}</td>
                  <td class="text-xs-left">{{ props.item.AdHocVisits }}</td>
                  <td class="text-xs-left">{{ props.item.TotalCompeleteVists }}</td>
                  <td class="text-xs-left">{{ props.item.PercentageComplete }}%</td>
                  <!--                  <td class="text-xs-left">{{ props.item.HitRate }}</td>-->
                </template>
              </v-data-table>
            </v-flex>
          </v-container>
        </v-layout>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
import Widget from "./Widget.vue";
import DataTable from "./DataTable.vue";
import TimeLine from "./TimeLine.vue";
import LocationStatistic from "./LocationStatistic.vue";
import SiteViewStatistic from "./SiteViewStatistic.vue";
import TotalEarningsStatistic from "./TotalEarningsStatistic.vue";
import moment from "moment";
import JWT from "jsonwebtoken";

export default {
  data() {
    return {
      tmp: [],
      selectedOpsManager: null,
      opsManagerList: [],
      role: null,
      userID: 0,
      startDate: null,
      endDate: null,
      startDateFormatted: this.formatStartDate(
        new Date().toISOString().substr(0, 10)
      ),
      endDateFormatted: this.formatEndDate(
        new Date().toISOString().substr(0, 10)
      ),
      menu1: false,
      menu2: false,
      CheckInsForToday: 0,
      today: moment(Date.now()).format("YYYY-MM-DD"),
      customerItems: [],
      selectedCustomer: null,
      venueItems: [],
      selectedVenue: null,
      opsManagerItems: [],
      search: null,
      opsManagerItemHeaders: [{},
      {
        value: "OpsManagerFullName",
        text: "Ops Manager",
        align: "left",
        sortable: true
      },
      {
        text: "Customer",
        value: "CustomerName",
        align: "left",
        sortable: true
      },
      {
        text: "Venue",
        value: "VenueName",
        align: "left",
        sortable: true
      },
      // {
      //   text: "Visit Type",
      //   value: "VisitType",
      //   align: "left",
      //   sortable: true
      // },
      {
        text: "Allocated Visits",
        value: "AllocatedVisits",
        align: "left",
        sortable: true
      },
      {
        text: "AdHoc Visits",
        value: "AdHocVisits",
        align: "left",
        sortable: true
      },
      {
        text: "Completed Visits",
        value: "TotalCompeleteVists",
        align: "left",
        sortable: true
      },
      {
        text: "% of Allocations Complete",
        value: "PercentageComplete",
        align: "left",
        sortable: true
      },
        // {
        //   text: "Hit Rate (%)",
        //   value: "HitRate",
        //   align: "left",
        //   sortable: true
        // }
      ],
      excelFields: {
        "Ops Manager": "OpsManagerFullName",
        Customer: "CustomerName",
        Venue: "VenueName",
        "Allocated Visits": "AllocatedVisits",
        "AdHoc Visits": "AdHocVisits",
        "Completed Visits": "TotalCompeleteVists",
        "% of Allocation Complete": "PercentageComplete",
      },
      excelData: [],
      fileName: null
    };
  },
  components: {
    Widget,
    DataTable,
    TimeLine,
    LocationStatistic,
    SiteViewStatistic,
    TotalEarningsStatistic
  },
  computed: {
    computedDateFormatted() {
      return this.formatStartDate(this.startDate);
      return this.formatEndDate(this.endDate);
    }
  },
  watch: {
    startDate(val) {
      this.startDateFormatted = this.formatStartDate(this.startDate);
    },
    endDate(value) {
      this.endDateFormatted = this.formatEndDate(this.endDate);
    }
  },
  mounted() {
    let self = this;
    let tokenDecoded = JWT.decode(localStorage.accessToken);
    console.log("[TOKEN DECODED]", tokenDecoded);

    self.userID = localStorage.getItem("USER_ID");
    console.log("USER_ID", self.userID);
    self.role = localStorage.getItem("Role");
    console.log("ROLE", self.role);

    var date = new Date();
    self.startDate = new Date(date.getFullYear(), date.getMonth(), 1)
      .toISOString()
      .substr(0, 10);
    self.endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0)
      .toISOString()
      .substr(0, 10);

    self.FetchOpsManagers();
  },
  methods: {
    FetchOpsManagers() {
      let self = this;

      self.get(`SystemUser/GetOpsManagers`).then(r => {
        console.log("[Ops-manager LIST]", r.data);
        self.opsManagerList = r.data;
      });
    },
    checkSelectedOpsManager() {
      let self = this;

      self.$nextTick(() => {
        console.log("selected ops-manager", self.selectedOpsManager);
      });
    },
    filterItems() {
      let self = this;
      if (self.selectedOpsManager.ID != null) {
        console.log("SELECTED DATES", self.startDate, self.endDate);
        self.menu2 = false;
        self.FetchVisits();
      }
    },
    FetchVisits() {
      let self = this;
      self.opsManagerItems = [];

      self.$refs.Loader.show(true);
      self.$refs.Loader.setText("Filtering items...");

      self
        .get(
          `SQLReporting/OpsVisits?start=${self.startDate}&end=${self.endDate}&systemUserID=${self.selectedOpsManager.ID}`
        )
        .then(r => {
          self.$refs.Loader.hide();

          r.data.forEach(visit => {
            visit.HitRate =
              parseFloat(
                (visit.ActualVisits / visit.ExpectedVisits) * 100
              ).toFixed(2) + "%";
            self.opsManagerItems.push(visit);
          });
        }).catch(err => {
          self.$refs.Loader.hide();
        });

    },
    clearFilter() {
      let self = this;
      self.opsManagerItems = [];
      self.selectedOpsManager = null;
    },
    triggerExcel() {
      let self = this;

      self.fileName = "Ops-manager-visits-" + self.today;
      self.excelData = self.opsManagerItems;
      var vueJsonExcel = self.$refs.downloadExcelRef;
      vueJsonExcel.$el.click();
    },
    // DATE FILTERING
    parseDate(date) {
      let self = this;
      console.log("PARSED DATE", date);
    },
    filterByDate() {
      let self = this;
      var labels = [];
      var data = [];

      console.log("[FILTER START DATE]", self.startDate);
      console.log("[FILTER END DATE]", self.endDate);
    },
    formatStartDate(startDate) {
      if (!startDate) return null;

      const [year, month, day] = startDate.split("-");
      return `${month}/${day}/${year}`;
    },
    formatEndDate(endDate) {
      if (!endDate) return null;

      const [year, month, day] = endDate.split("-");
      return `${month}/${day}/${year}`;
    },
    parseStartDate(startDate) {
      if (!startDate) return null;

      const [month, day, year] = startDate.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    parseEndDate(endDate) {
      if (!endDate) return null;

      const [month, day, year] = endDate.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  }
};
</script>

<style></style>